/**
 * Confirmation dialog for destructive actions (deletes). Same inline Bootstrap
 * modal markup the pages already use, so it needs no Bootstrap JS.
 * 9027: also a summary to confirm before an action is sent — pass `variant`,
 * `icon`, `size` and a `testId` for it; the defaults keep the delete dialog.
 */
export default function ConfirmModal({
  open,
  title = 'Please confirm',
  message,
  confirmLabel = 'Delete',
  busy = false,
  onConfirm,
  onCancel,
  variant = 'danger',
  icon = 'fa-exclamation-triangle text-danger',
  size = '',
  testId = 'confirm-modal',
  error = '',
}) {
  if (!open) return null;
  return (
    <>
      <div className="modal d-block" tabIndex={-1} role="dialog" data-testid={testId}>
        <div className={`modal-dialog modal-dialog-centered${size ? ` modal-${size}` : ''}`}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className={`fas ${icon} me-2`} aria-hidden="true" />
                {title}
              </h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onCancel} disabled={busy} />
            </div>
            <div className="modal-body">
              {error && (
                <div className="alert alert-danger" role="alert" data-testid="confirm-error">
                  {error}
                </div>
              )}
              {message}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" data-testid="confirm-cancel" onClick={onCancel} disabled={busy}>
                Cancel
              </button>
              <button type="button" className={`btn btn-${variant}`} data-testid="confirm-ok" onClick={onConfirm} disabled={busy}>
                {busy && <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />}
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}
